"use client";

import React from "react";
import { Clock, Shield, Tag } from "lucide-react";
import { Card, CardContent, CardHeader, CardTitle } from "@/components/ui/card";
import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
const features = [{
  id: "price",
  title: "Lower Insurance Premiums",
  description: "Most Florida homeowners qualify for significant insurance discounts after a wind mitigation inspection. We help you identify every possible credit available."
}, {
  id: "insurance",
  title: "Certified Protection",
  description: "Our licensed inspectors verify your home's structural integrity against high winds, ensuring your family and investment are properly protected."
}, {
  id: "time",
  title: "Fast Report Delivery",
  description: "Time is of the essence for your policy. We provide detailed, insurance-ready digital reports within 24 hours of completing your inspection."
}];
export default function WhyWartmannUmzuege() {
  const {
    ref,
    isVisible
  } = useRevealOnScroll({
    threshold: 0.1
  });
  return <section data-section-id="222589" id="benefits" className="bg-background py-24 md:py-32 overflow-hidden">
      <div className="container mx-auto px-4 md:px-6">
        <div ref={ref} className={`max-w-3xl mx-auto text-center mb-16 transition-all duration-700 ease-out ${isVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-8"}`}>
          <h2 className="font-default text-3xl md:text-4xl lg:text-5xl font-bold text-foreground tracking-tight mb-6">
            Why Get a Wind Mitigation?
          </h2>
          <p className="text-lg md:text-xl text-muted-foreground leading-relaxed font-default">
            Protect your home and your wallet. Our specialized inspections are designed to 
            maximize your safety while minimizing your annual insurance expenditures.
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-8 max-w-6xl mx-auto">
          {features.map((feature, i) => {
          const Icon = feature.id === "price" ? Tag : feature.id === "insurance" ? Shield : Clock;
          return <div key={feature.id} data-index={i} className={`transition-all duration-700 ease-out delay-${i * 100}`} style={{
            opacity: isVisible ? 1 : 0,
            transform: isVisible ? "translateY(0)" : "translateY(32px)",
            transitionDelay: `${i * 150}ms`
          }}>
                <Card className="h-full border-border bg-card shadow-sm hover:shadow-xl hover:-translate-y-2 transition-all duration-300 group rounded-lg">
                  <CardHeader className="pb-4">
                    <div className="w-14 h-14 rounded-2xl bg-primary/10 flex items-center justify-center mb-4 group-hover:bg-primary/20 transition-colors duration-300">
                      <Icon className="w-7 h-7 text-primary" strokeWidth={1.5} />
                    </div>
                    <CardTitle className="font-default text-xl md:text-2xl text-foreground font-bold">
                      {feature.title}
                    </CardTitle>
                  </CardHeader>
                  <CardContent>
                    <p className="text-muted-foreground leading-relaxed font-default">
                      {feature.description}
                    </p>
                  </CardContent>
                </Card>
              </div>;
        })}
        </div>
      </div>
    </section>;
}